export default state => parseInt(state.search.query?.page) || 1;
